import _get from "lodash/get";
import React from 'react';
import { SrLabel } from '~helpers';
import { GaIcon } from '~icon';
import carouselPropTypes from '../prop-types/carouselPropTypes';
import Arrow from './Arrow';
import carouselTheme from '../styles/carouselTheme';

var ArrowIcon = function ArrowIcon(_ref) {
  var arrowSize = _ref.arrowSize,
      arrowType = _ref.arrowType,
      arrowCustomColor = _ref.arrowCustomColor,
      slide = _ref.slide,
      rtl = _ref.rtl,
      label = _ref.label,
      icon = _ref.icon,
      vertical = _ref.vertical,
      theme = _ref.theme;
  var iconValue;

  var iconHorizontalPrev = _get(theme, 'carousel.arrows.horizontal.iconPrev', carouselTheme.carousel.arrows.horizontal.iconPrev);

  var iconVerticalPrev = _get(theme, 'carousel.arrows.vertical.iconPrev', carouselTheme.carousel.arrows.vertical.iconPrev);

  var iconHorizontalNext = _get(theme, 'carousel.arrows.horizontal.iconNext', carouselTheme.carousel.arrows.horizontal.iconNext);

  var iconVerticalNext = _get(theme, 'carousel.arrows.vertical.iconNext', carouselTheme.carousel.arrows.vertical.iconNext);

  var arrowSizeValue = _get(theme, "carousel.arrows[" + arrowSize + "].iconSize", carouselTheme.carousel.arrows[arrowSize].iconSize);

  var arrowColor = _get(theme, "carousel.arrows.color[" + arrowType + "]", carouselTheme.carousel.arrows.color[arrowType]);

  var renderArrowColor = arrowCustomColor || arrowColor;
  var renderIconPrev = vertical ? iconVerticalPrev : iconHorizontalPrev;
  var renderIconNext = vertical ? iconVerticalNext : iconHorizontalNext;

  if (slide === 'prev') {
    if (rtl) {
      iconValue = iconHorizontalNext;
    }

    iconValue = renderIconPrev;
  }

  if (slide === 'next') {
    if (rtl) {
      iconValue = iconHorizontalPrev;
    }

    iconValue = renderIconNext;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, icon && /*#__PURE__*/React.createElement(Arrow, {
    vertical: vertical,
    arrowSize: arrowSize,
    arrowType: arrowType,
    slide: slide,
    rtl: rtl
  }, /*#__PURE__*/React.createElement(GaIcon, {
    icon: iconValue,
    size: arrowSizeValue,
    color: renderArrowColor
  })), label && /*#__PURE__*/React.createElement(SrLabel, {
    as: "span"
  }, label));
};

ArrowIcon.defaultProps = {
  icon: true,
  arrowSize: 'default',
  arrowType: 'default',
  arrowCustomColor: null,
  rtl: false,
  label: null,
  vertical: false,
  theme: {}
};
export default ArrowIcon;